import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup, FormControl } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FormInputComponent } from '../../../components/ui-components/forms/form-input/form-input.component';
import { CardButtonComponent } from '../../../components/ui-components/buttons/card-button/card-button.component';
import { CardButtonBackground, CardButtonSize } from '../../../components/ui-components/buttons/card-button/card-button.model';
import { FormInputType } from '../../../components/ui-components/forms/form-input/form-input.model';
import { TenderType } from 'src/app/services/model/tender-type.enum';
import { ReportExportService } from 'src/app/services/report-export.service';
import { DropdownComponent } from '../../../components/ui-components/dropdown/dropdown.component';
import { DropdownOption } from 'src/app/components/ui-components/dropdown/dropdown.model';

@Component({
  selector: 'app-movement-report',
  templateUrl: './movement-report.component.html',
  styleUrls: ['./movement-report.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    FormInputComponent,
    CardButtonComponent,
    DropdownComponent
],
})
export class MovementReportComponent {
  constructor(
    private reportExportService: ReportExportService
  ) {}

  reportForm = new FormGroup({
    dateFrom: new FormControl(''),
    dateTo: new FormControl(''),
    tenderType: new FormControl(''),
    bnrVs: new FormControl(''),
    amountFrom: new FormControl(''),
    amountTo: new FormControl(''),
  });

  CardButtonSize = CardButtonSize;
  CardButtonBackground = CardButtonBackground;
  FormInputType = FormInputType;
  
  tenderTypes: DropdownOption[] = Object.keys(TenderType)
    .filter(key => !isNaN(Number(TenderType[key])))
    .map(key => ({ value: TenderType[key], label: key }));

  search() {
    console.log(this.reportForm.value);
  }

  downloadReportPdf(): void {
    const iframe = document.getElementsByName('report-iframe')[0] as HTMLIFrameElement | undefined;
    if (!this.reportExportService.requestExportFromIframe(iframe, { showProcessingDialog: true })) {
      console.warn('Report iframe is not ready for export');
    }
  }
}
